import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import Style from './PaymentInfoForm.module.scss'
import { Button } from 'react-bootstrap';
import DatePicker from "@amir04lm26/react-modern-calendar-date-picker";
import { convertToTimestamp } from '../../../Utils/ConvertStamp';
import { WithdrawRequesAPI } from '../../../Api/PanelAdminServices';
import { errorToast, succToast } from '../../../Utils/Toast/Toast';
import moment from 'moment-jalaali';

const PaymentInfoForm = ({info,updateHandler,closeModal}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [selectedDay, setSelectedDay] = useState(null);
  const onSubmit = (data) => {
    const stamptArgumants=`${selectedDay.year}/${selectedDay.month}/${selectedDay.day} ${data.hour}:${data.minuts}`
    const timeStamp=convertToTimestamp(stamptArgumants)
    const bodyData={
      id:info.key,
      track_id:data.track_id,
      withdraw_date:timeStamp,
      source_withdraw:'bmi'
    }
    WithdrawRequesAPI(bodyData,(res)=>{
      if(res.status===1){
        succToast('باموفقیت انجام شد!')
        updateHandler()
        closeModal()
      }else{
        errorToast(res.message)
      }
    })
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)} className={Style.formPart}>
    <div
      className={errors.track_id ? Style.isInvalid : Style.inputHolder}
    >
      <input
        {...register("track_id", { required: true })}
        type="text"
        className={Style.valid}
        size="large"
        placeholder="شماره رهگیری"

      />
    </div>
    <div
      className={errors.username ? Style.isInvalid : Style.inputHolder}
    >
          <DatePicker
      value={selectedDay}
      onChange={setSelectedDay}
      shouldHighlightWeekends
      locale="fa" // add this
    />
    </div>
    <div
      className={errors.hour ? Style.isInvalid : Style.inputHolder}
    >
      <input
        {...register("hour", { required: true })}
        type="text"
        className={Style.valid}
        size="large"
        placeholder="ساعت با فرمت 24 ساعت"

      />
    </div>
    <div
      className={errors.minuts ? Style.isInvalid : Style.inputHolder}
    >
      <input
        {...register("minuts", { required: true })}
        type="text"
        className={Style.valid}
        size="large"
        placeholder="دقیقه"

      />
    </div>

    <Button
      style={{ background: "#c20c64", border: "none",width:'100%' }}
      type="submit"
    >
      ثبت
    </Button>
  </form>
  )
}

export default PaymentInfoForm